// extracted by mini-css-extract-plugin
module.exports = {"HeaderContainer":"_39_Wgk_-","HeaderTransparent":"_2aRbrhPe","button":"_1xnMwy1U","Header":"_3OaPJfsK","headerBoxShadow":"_2mE-FhM2","LogoBlock":"_1YclcA4s","navLinksContainer":"V81ih_M0","navLink":"_3HTMvuZM","activeNavLink":"nw6KZJsF","darkLogo":"_1pvkier8","NavDropdown":"_3bIwGdXH","NavHamburger":"_4bSm03to","seafoam":"_2ujhF_Gd","NavBlock":"_2O0geX_k"};
    if(module.hot) {
      // 1746735760487
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  